
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from "@/components/ui/select";

interface ProfileAddressSectionProps {
  address: string;
  city: string;
  state: string;
  postalCode: string;
  onAddressChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCityChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onStateChange: (value: string) => void;
  onPostalCodeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ProfileAddressSection = ({
  address,
  city,
  state,
  postalCode,
  onAddressChange,
  onCityChange,
  onStateChange,
  onPostalCodeChange,
}: ProfileAddressSectionProps) => {
  // List of US states for dropdown
  const states = [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", 
    "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", 
    "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", 
    "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", 
    "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", 
    "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", 
    "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
  ];

  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="address">Address</Label>
        <Input
          id="address"
          value={address}
          onChange={onAddressChange}
          placeholder="Street address"
          className="bg-[#EDEDED] border-gray-200 placeholder:text-[#6B6B6B]"
        />
      </div>
      
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="city">City</Label>
          <Input
            id="city"
            value={city}
            onChange={onCityChange}
            placeholder="City"
            className="bg-[#EDEDED] border-gray-200 placeholder:text-[#6B6B6B]"
          />
        </div>
        
        <div>
          <Label htmlFor="state">State</Label>
          <Select
            value={state}
            onValueChange={onStateChange}
          >
            <SelectTrigger id="state" className="bg-[#EDEDED] border-gray-200">
              <SelectValue placeholder="Select state" />
            </SelectTrigger>
            <SelectContent>
              {states.map((stateName) => (
                <SelectItem key={stateName} value={stateName}>
                  {stateName}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
      
      <div>
        <Label htmlFor="postalCode">ZIP / Postal Code</Label>
        <Input
          id="postalCode"
          value={postalCode}
          onChange={onPostalCodeChange}
          placeholder="ZIP / Postal code"
          className="bg-[#EDEDED] border-gray-200 placeholder:text-[#6B6B6B]"
        />
      </div>
    </div>
  );
};
